import type { ProjectProduct } from '@xver/apis/v1/projects/model';
import { ConfigurationBox } from '@xver/components/Atoms';
import { useActiveProject } from '@xver/hooks/useActiveProject';
import { useTranslation } from 'react-i18next';
import ProjectSwitcher from '../ProjectSwitcher/ProjectSwitcher';

/**
 * A deploy form's "Project" section. Picking a project switches the active project, which every
 * create call and scoped query already follows. Renders nothing until a project is resolved.
 */
export default function DeployProjectSection({ product }: { product: ProjectProduct }) {
    const { t } = useTranslation('projects');
    const { project } = useActiveProject();

    if (!project) return null;

    return (
        <ConfigurationBox
            label={t('deploy.section.title')}
            leftDescription={t('deploy.section.description')}
        >
            <ProjectSwitcher
                product={product}
                label={t('deploy.section.label')}
                className="sm:max-w-md self-start"
            />
        </ConfigurationBox>
    );
}
